module.exports = __webpack_public_path__ + "static/media/418.d4b78ccc.png";